export enum PASSWORD_LIMIT {
    min = 8,
    max = 24,
    lessMin = 6,
}